const easeInOutQuad = ({
  currentTime,
  start,
  change,
  duration,
}: {
  currentTime: number;
  start: number;
  change: number;
  duration: number;
}): number => {
  let current = currentTime;
  current /= duration / 2;
  if (current < 1) {
    return (change / 2) * current * current + start;
  }
  current -= 1;
  return (-change / 2) * (current * (current - 2) - 1) + start;
};

export default function scrollTo(
  e: HTMLElement,
  to: number,
  duration: number,
  scroll = 'y',
): void {
  const element = e;
  const scrollAxis = scroll === 'y' ? 'scrollTop' : 'scrollLeft';
  const start = element[scrollAxis];
  const change = to - start;
  let currentTime = 0;
  const increment = 20;

  const animateScroll = (): void => {
    currentTime += increment;
    const val = easeInOutQuad({
      currentTime,
      start,
      change,
      duration,
    });
    element[scrollAxis] = val;
    if (currentTime < duration) {
      setTimeout(animateScroll, increment);
    }
  };
  animateScroll();
}
